import { Tooltip as AntdTooltip } from 'antd';
import 'antd/es/tooltip/style/index.css';
import './index.less';
import { TooltipProps } from 'antd/es/tooltip';

const Tooltip = ({ children, ...props }: TooltipProps) => {
    return (
        <AntdTooltip {...props} mouseEnterDelay={props.mouseEnterDelay ?? 0.3}>
            {children}
        </AntdTooltip>
    );
};

export default Tooltip;
